module.exports = __webpack_public_path__ + "static/media/quadro.d1fed8bf.png";